// Imports
import { useRef /*useEffect*/ } from 'react';
import { useOutletContext } from 'react-router-dom';
import Input from '../../../../../../../shareables/foundation/front-end/components/forms/fields/input';
import commonActions from '../../../../../../../shareables/foundation/front-end/redux/actions';
import { useAppDispatch } from '../../../../../../../shareables/foundation/front-end/redux/hooks';
import APIForm, { APIFormOptions } from '../../../../../../../shareables/integrations/api/components/form';
import { PutPasswordParameters } from '../../../../../../../shareables/types/api/main/self/password/put';


// Function component
const Password: React.FC = () => {
	// Use Redux functionality
	const dispatch = useAppDispatch();
	
	
	// Use ref
	const ref = useRef<HTMLFormElement | null>(null);
	
	
	// Use React Router functionality
	const updateHeight: (newHeight: number) => void = useOutletContext();
	
	
	// Update height for the members settings page
	if (ref.current) {
		updateHeight(ref.current.clientHeight);
	}
	
	
	// Form options
	const formOptions: APIFormOptions<PutPasswordParameters, undefined, undefined> = {
		action: 'PUT',
		uri: '/self/password',
		submitButton: {
			text: 'Save',
		},
		recoverState: false,
	};
	
	
	// Handle form completion
	const handleFormCompletion = () => {
		dispatch(
			commonActions.showPageMessage({
				color: 'success',
				title: 'Success',
				message: 'Your new password has been saved.',
			})
		);
	};
	
	
	// Return JSX
	return (
		<APIForm options={formOptions} onCompletion={handleFormCompletion} ref={ref}>
			<Input
				name='password'
				type='password'
				label='New password'
				note='(Case sensitive)'
				placeholder='••••••••••'
				data-private
				showStrength
				required
			/>
		</APIForm>
	);
};

export default Password;
